import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2022-12-19.
 */

export class BenjiKIVSFSMoreScatterRunner implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;
    private _controller:SimplePresentationRunnerController;

    public shouldRun():boolean {
        return BenjiKIV.model.sfsIsMoreScatter;
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;

        this._mainTL = gsap.timeline({
            onComplete : () => {
                this.complete();
            }
        });
        this._mainTL.add(BenjiKIV.sfsMoreScatterView.getSFSMoreScatterTL());
    }

    private complete():void {
        this._controller.finish();
    }
}